

<div class="acquisition_top" style="margin-bottom: 1rem;" >
  <!-- top left part  -->
<!-- <pre>{{landTitle | json}}</pre> -->
  <div class="log">
    <h2 class="title">Land Acquisition</h2>
    <div class="history" >
    </div>
  </div>

  <!-- top right part -->

  <div class="filter_search">
    <div class="search_container">
      <input type="text"  #search class="default_input search search_land" placeholder="Search" />
      <i class="ti-search"></i>
    </div>
    <button class="default_secondary-btn filter" (click)="onFilter()">Filter <i class="ti-filter"></i></button>
    <button *ngIf="selectedActivity && showCreateBtn" class="default_secondary-btn Add_new" (click)="createEvent()">Create New<i class="ti-plus"></i></button>
  </div>
</div>

<div style="width:93%; padding-left:3rem" class="row" *ngIf="task === 'list' && view === 'mainSearch' && isFilter">
  <div class="col-md-4">
    <div class="row">
      <div class="col-md-10">
        <mat-form-field class="full-width-field" id="id_numer">
          <mat-select
            placeholder="Select Group"
            (selectionChange)="onFilterSubGroup($event.value)"
            style="font-size: 1.2vw;"
          >
            <mat-option *ngFor="let group of groups" [value]="group.id">{{
              group.GroupName
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-2">
        <span *ngIf="selectedGroupId" (click)="filterWithGroupId()"
          ><img
            style="
              width: 20px;
              height: 20px;
              margin-top: 12px;
              cursor: pointer;
            "
            src="assets/images/top_nav/Magnifiction.svg"
            alt=""
            class="magnify"
        /></span>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="row">
      <div class="col-md-10">
        <mat-form-field class="full-width-field" id="id_nmber">
          <mat-select
            placeholder="Select Sub Group"
            (selectionChange)="onFilterSubSubGroup($event.value)"
            style="font-size: 1.2vw;"
          >
            <mat-option
              *ngFor="let subGroup of filterSubGroup"
              [value]="subGroup.id"
              >{{ subGroup.SubGroupName }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-2">
        <span *ngIf="selectedSubGroupId" (click)="filterWithSubGroupId()"
          ><img
            style="
              width: 20px;
              height: 20px;
              margin-top: 12px;
              cursor: pointer;
            "
            src="assets/images/top_nav/Magnifiction.svg"
            alt=""
            class="magnify"
        /></span>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="row">
      <div class="col-md-10">
        <mat-form-field class="full-width-field" id="id_nmber">
          <mat-select
            placeholder="Select Sub Sub Group"
            (selectionChange)="onSelectSubSubGroupId($event.value)"
            style="font-size: 1.2vw;"
          >
            <mat-option
              *ngFor="let subSubGroup of filterSubSubGroup"
              [value]="subSubGroup.id"
              >{{ subSubGroup.SubSubGroupName }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-2">
        <span *ngIf="selectedSubSubGroupId" (click)="filterWithSubSubGroupId()"
          ><img
            style="
              width: 20px;
              height: 20px;
              margin-top: 12px;
              cursor: pointer;
            "
            src="assets/images/top_nav/Magnifiction.svg"
            alt=""
            class="magnify"
        /></span>
      </div>
    </div>
  </div>
</div>
